import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["list", "output", "template"]
  }

  connect() {
    this.nextId = this.nextBlockId()
    this.updateControls()
    this.serialize()
  }

  addBlock(event) {
    const type = event.params.type
    const template = this.templateTargets.find((target) => target.dataset.blockType === type)
    if (!template) return

    const row = template.content.firstElementChild.cloneNode(true)
    this.prepareNewRow(row)
    this.listTarget.appendChild(row)
    this.updateControls()
    this.serialize()
  }

  moveUp(event) {
    const row = this.rowForEvent(event)
    const previous = row && row.previousElementSibling
    if (!previous) return

    this.listTarget.insertBefore(row, previous)
    this.afterRowsChanged()
  }

  moveDown(event) {
    const row = this.rowForEvent(event)
    const next = row && row.nextElementSibling
    if (!next) return

    this.listTarget.insertBefore(next, row)
    this.afterRowsChanged()
  }

  confirmRemove(event) {
    const row = this.rowForEvent(event)
    row.querySelector("[data-remove-trigger]").hidden = true
    row.querySelector("[data-remove-confirm]").hidden = false
  }

  cancelRemove(event) {
    const row = this.rowForEvent(event)
    this.hideRemoveConfirmation(row)
  }

  removeBlock(event) {
    const row = this.rowForEvent(event)
    row.remove()
    this.afterRowsChanged()
  }

  handleBlockChanged(event) {
    const row = event.target.closest("[data-block-id]")
    if (!row) return

    row.dataset.blockData = JSON.stringify(event.detail.blockData || {})
    this.serialize()
  }

  prepareNewRow(row) {
    const blockId = this.nextId
    this.nextId += 1

    row.dataset.blockId = String(blockId)
    const photoV1Block = row.querySelector("[data-homer-photo-v1-block-block-id-value]")
    if (photoV1Block) photoV1Block.dataset.homerPhotoV1BlockBlockIdValue = String(blockId)
  }

  afterRowsChanged() {
    this.updateControls()
    this.serialize()
  }

  updateControls() {
    const rows = this.rows
    rows.forEach((row, index) => {
      const controls = row.querySelector("[data-edit-controls]")
      if (controls) controls.hidden = rows.length <= 1

      const up = row.querySelector("[data-move-up]")
      if (up) up.hidden = rows.length <= 1 || index === 0

      const down = row.querySelector("[data-move-down]")
      if (down) down.hidden = rows.length <= 1 || index === rows.length - 1
    })
  }

  serialize() {
    this.outputTarget.value = JSON.stringify(
      this.rows.map((row, index) => ({
        id: this.blockId(row),
        position: index,
        type: row.dataset.blockType,
        block_data: this.blockData(row)
      }))
    )
  }

  hideRemoveConfirmation(row) {
    row.querySelector("[data-remove-trigger]").hidden = false
    row.querySelector("[data-remove-confirm]").hidden = true
  }

  rowForEvent(event) {
    return event.target.closest("[data-block-id]")
  }

  nextBlockId() {
    const ids = this.rows.map((row) => this.blockId(row)).filter((id) => Number.isInteger(id))
    return ids.length ? Math.max(...ids) + 1 : 1
  }

  blockId(row) {
    const id = row.dataset.blockId
    return /^\d+$/.test(id) ? parseInt(id, 10) : id
  }

  blockData(row) {
    return JSON.parse(row.dataset.blockData || "{}")
  }

  get rows() {
    return Array.from(this.listTarget.children)
  }
}
